import get from "lodash.get";

export default function t (key, defaultText) {
    const trs = window.ITI18n.translations;
    const translated = get(trs, key); 
    if (!translated) {
        console.warn("ITI18n - Couldn't translate: " + key )
    }
    return translated || defaultText || key;
}